import { createContext, useContext } from "react"
import { IProfileService } from "../types";

export const ProfileServiceContext = createContext({} as IProfileService);

export function useProfileService() {
    return useContext(ProfileServiceContext);
}